import { Fragment } from 'react';
import { Box, FormControlLabel, Stack, Switch, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const ACCENT = '#2196f3';
const WARNING = '#e65100';

const switchSx = {
  '& .MuiSwitch-switchBase.Mui-checked': { color: ACCENT },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: ACCENT },
};

/**
 * Shows or hides the hours outside opening time on both boards (DECISIONS.md D24). They are hidden
 * by default, which makes a booking an admin placed there easy to miss — so when today or tomorrow
 * has one, the toggle carries an exclamation mark and says when. It keeps to the dashboard's
 * neutral palette rather than the theme's.
 */
const OutsideHoursToggle = ({ checked, onChange, upcomingGuests }) => (
  <Stack alignItems="center" spacing={0.25}>
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <FormControlLabel
        control={<Switch checked={checked} onChange={onChange} size="small" sx={switchSx} />}
        label="Nyitvatartási időn kívüli idősávok"
        sx={{ mr: 0, '& .MuiFormControlLabel-label': { fontSize: '14px', color: '#333' } }}
      />
      {upcomingGuests.length > 0 && (
        <ErrorOutlineIcon aria-hidden data-testid="outside-hours-alert" sx={{ fontSize: 20, color: WARNING }} />
      )}
    </Stack>
    {upcomingGuests.map(({ isToday, ranges }) => (
      <Typography
        key={isToday ? 'today' : 'tomorrow'}
        data-testid="outside-hours-notice"
        sx={{ fontSize: '12px', color: WARNING, textAlign: 'center' }}
      >
        {isToday ? 'Ma' : 'Holnap'} nyitvatartási időn kívül is lesz vendég:{' '}
        {/* A line may break between two ranges, never inside one. */}
        {ranges.map((range, index) => (
          <Fragment key={range}>
            {index > 0 && ', '}
            <Box component="span" sx={{ whiteSpace: 'nowrap' }}>{range}</Box>
          </Fragment>
        ))}
      </Typography>
    ))}
  </Stack>
);

export default OutsideHoursToggle;
